import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { message } from 'antd';
import { ApiResponse } from '../../interfaces/request';
import { clearAuthCookies, getAgentId, getEntId, getToken } from '..';
import env from '../env';
import { NoPermissionError, ResultExeptionError, ServiceExeptionError } from './errors';

const TIMEOUT = 60 * 1000;

axios.defaults.timeout = TIMEOUT;
axios.defaults.headers.common['Content-Type'] = 'application/json';

const defaultInstance = axios.create({
  baseURL: `${env.API_URL}/luna/core/api`,
  headers: { Authorization: getToken() },
});
const oldInstance = axios.create({
  baseURL: `${env.API_URL}`,
  headers: { Authorization: getToken() },
});
const cafeInstance = axios.create({
  baseURL: `${env.API_URL}/meiqia/cafe`,
  headers: {
    Authorization: getToken(),
    'Accept-Language': 'zh',
    'X-Cafe-OrgId': env.ORG_ID,
    'X-Cafe-AgentId': getAgentId(),
    'X-cafe-enttoken': getEntId(),
  },
});

const handleRequestError = (err: AxiosError) => {
  if (err.response?.status === 401 || err.code === 'ECONNABORTED') {
    clearAuthCookies();
    window.location.href = '/login';
    return Promise.reject(new NoPermissionError());
  } else {
    return Promise.reject(
      new ServiceExeptionError(
        err.message === 'Network Error' ? '网络错误，请检查网络设置' : err.message,
      ),
    );
  }
};

async function baseRequest<T>(config: AxiosRequestConfig): Promise<T> {
  return defaultInstance<ApiResponse<T>>(config)
    .then((res) => {
      const result = res.data;
      if (result.code === 1) {
        return result.data;
      }
      return Promise.reject(new ResultExeptionError(result.msg));
    })
    .catch(handleRequestError);
}
async function oldRequest<T>(config: AxiosRequestConfig): Promise<T> {
  return oldInstance<ApiResponse<T>>(config)
    .then((res) => {
      const result = res.data;
      if (result.code === 1) {
        return result.data;
      }
      return Promise.reject(new ResultExeptionError(result.msg));
    })
    .catch(handleRequestError);
}
async function keepAliveFetch(url: string, data: object) {
  return fetch(`${env.API_URL}/luna/core/api${url}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: getToken() } as any,
    body: JSON.stringify(data),
    keepalive: true,
  });
}

async function cafeRequest<T>(config: AxiosRequestConfig): Promise<T> {
  return cafeInstance<ApiResponse<T>>(config)
    .then((res) => {
      const result = res.data;
      if (result.code === 1) {
        return result.data;
      }
      return Promise.reject(new ResultExeptionError(result.msg));
    })
    .catch(handleRequestError);
}

type RequestInst = typeof baseRequest & {
  old: typeof oldRequest;
  keepAliveFetch: typeof keepAliveFetch;
  cafe: typeof cafeRequest;
};
const request = baseRequest as RequestInst;
request.old = oldRequest;
request.keepAliveFetch = keepAliveFetch;
request.cafe = cafeRequest;

export default request;

export const errorHandler = (err: Error) => {
  console.error(err);

  // if (err instanceof NoPermissionError) {
  //   clearAuthCookies();
  //   window.location.href = '/login';
  //   return;
  // }
  // handle other errors

  message.error(err.message);
};
